import {
  OrdersFiltersPresentation,
  type OrdersFiltersPresentationProps,
} from "./OrdersFilters.pres";

export type OrdersFiltersConnectorProps = OrdersFiltersPresentationProps;

export const OrdersFilters = (props: OrdersFiltersConnectorProps) => (
  <OrdersFiltersPresentation {...props} />
);
